<template>  
  <div>            
     <template v-if="loaded || !endMissionMode">   
      <mission-simulation-line-detail :uiid="uiid" :mission="missionDetail" v-if="(vimStatus == 10 || (mission.result && mission.result.error_msg && mission.result.error_msg.startsWith('Battery limit'))) && (!endMissionMode || typeUiid=='detail' )" :endMissionMode="endMissionMode" />        
      <h2 class="body-2 text-uppercase primary--text" :class="{'secondary--text':endMissionMode}" v-if="(vimStatus == 10 || (mission.result && mission.result.error_msg && mission.result.error_msg.startsWith('Battery limit'))) && (!endMissionMode || typeUiid=='detail' )">{{$t('Simulation.Result')}}</h2>                     
      <table class="mrs-tbl" cellspacing="0" v-if="mission.result">
        <thead>
          <tr>          
            <td>{{$t('Pilot.MissionDrawer.Distance')}}</td>
            <td>{{$t('Simulation.StartDate')}}</td>
            <td>{{$t('Simulation.EndDate')}}</td>
            <td>{{$t('Pilot.MissionDrawer.MissionDuration')}}</td>
            <td>{{$t('Simulation.CyclesNb')}}</td>
            <td>{{$t('Simulation.EnergyAvailable')}} (%)</td>                                
          </tr>
        </thead>
        <tr>
            <td>{{ $options.filters.formatDistance(mission.result.distance_traveled * 1000) }}</td>
            <td>{{ missionStartDate | formatDate("DD/MM/YYYY HH:mm:ss") }}</td>
            <td>{{ mission.result.mission_end_date | formatDate("DD/MM/YYYY HH:mm:ss") }}</td>
            <td>{{ [new Date(missionStartDate) , new Date(missionCurEndDate)] | formatDuree($i18n) }}</td>
            <td>{{ nbYos }}</td>
            <td>{{ energy_available && energy_available.toFixed(2) }} </td>            
          </tr>
      </table>                   
      <template v-if="showError"><br/><strong>{{$t("Simulation.Error")}} :</strong> <span class="red--text darken-1">{{ mission.result.error_msg }}</span></template>              
    </template>    
    <template  v-else>
      {{$t("Pilot.MissionDrawer.Loading")}}
      <v-progress-linear indeterminate color="primary" ></v-progress-linear>      
    </template>     
  </div>        
</template>
<script lang="ts">


import Vue from 'vue'
import Component from 'vue-class-component'
import MissionTimeLine from '@/components/mission/MissionTimeLine.vue'
import MissionSimulationLineDetail from '@/components/mission/MissionSimulationLineDetail.vue'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
import { AloMission } from '@/models/alo/AloMission'
// import distance from '@turf/distance'
// import {point} from '@turf/helpers'

@Component({
name: 'SimulationMissionLineDetail',  
components:{MissionTimeLine,MissionSimulationLineDetail},
props:{  
  mission:{
    type:Object,
    required:true
  },
  typeUiid:{
    type:String,
    default:"global"
  },
  endMissionMode:{
    type:Boolean,    
    default:false
  }
}})
export default class SimulationMissionLineDetail extends Vue {      
  
  mission!:any // AloDbMissionVirtual|AloMission
  typeUiid!:string
  endMissionMode!:boolean

  get loaded() {    
    return this.endMissionMode?this.mission?.simulation?._detailLoaded:this.mission?.mission?._detailLoaded
  }

  get missionDetail(){    
    return this.endMissionMode?this.mission?.simulation:this.mission?.mission
  }

  get vimStatus(){    
    return this.endMissionMode?this.mission?.vimStatus:this.mission?.VIM_STATUS
  }
  

  get showError() {
    return (this.mission?.result?.error_msg?.length ?? 0) > 0
  }

  get missionStartDate()  {
    return this.mission?.param?.mission_start_date
  }
  
  get missionCurEndDate()  {
    return (this.mission?.result?.mission_end_date?.length ?? 0) > 0?this.mission?.result?.mission_end_date:this.mission?.result?.current_date
  }
  
  get energy_available(){
    return this.mission?.result?.energy_available ?? this.mission?.result?.current_battery
  } 

  get nbYos(){
    return this.mission?.result?.cycle_number ?? this.mission?.result?.current_cycle
  }


  get uiid() {
    return buildMissionUIStateId(this.endMissionMode?this.mission?.simulation?.misId!:this.mission?.id!,this.typeUiid)
  }
  /*
  get missionState() {            
    return this.$store.myGetters.uistatebyuiid(buildMissionUIStateId(Math.abs(this.mission.id!),'detail'))
  }

  get timelineIndex(){
    return this.missionState?.timelineIndex ?? 0
  }*/

  // get distanceCalcule() {
  //   return this.mission.mission.yoArray.reduce((result,yo)=>{      
  //     const coord = point([yo.yoGpsLon!,yo.yoGpsLat!])      
  //     return {
  //       prevCoord:coord,
  //       dist:result.prevCoord?(result.dist + distance(result.prevCoord,coord) ):0
  //     }
  //   },{prevCoord:null,dist:0} as {prevCoord:any,dist:number}).dist
  // }
  

}

</script> 

<style scoped>


</style>
